<div class="col-sm-12">
  <app-card [cardOptionBtnValue]="'admin.model.show.edit.model'|translate"
            [cardOptionBtn]="true"
            [cardRouterLink]="'/back-office/model/' + model.id"
            [title]="'admin.model.show.model information'|translate">
    <div class="row">
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.model.name'|translate}}</p>
        <label class="m-b-15">{{model.name}}</label>
      </div>
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.model.code'|translate}}</p>
        <label class=" m-b-15">{{model.code}}</label>
      </div>
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.model.attach_products'|translate}}</p>
        <label class="m-b-15">{{model.productCount}}</label>
      </div>
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.model.collection'|translate}}</p>
        <label class="m-b-15">{{(model.collection) ? model.collection.name : ''}}</label>
      </div>
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.model.styles'|translate}}</p>
        <label class="m-b-15">
          <ng-container *ngIf="hasStyle;else noStyle">
            <span
              *ngFor="let style of model.styles;let last=last;let index=index;">{{style.name}}{{last ? '' : ',' }}
            </span>
          </ng-container>
          <ng-template #noStyle>{{'admin.style.no_style.empty'|translate}}</ng-template>
        </label>
      </div>
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.model.status'|translate}}</p>
        <label class="m-b-15">
          {{(model.status ? 'global.active' : 'global.inactive')|translate}}</label>
      </div>
    </div>
  </app-card>
  <app-card [title]="'admin.model.show.edit.models'|translate"
            [cardOptionBtnValue]="'admin.product.show.add.product'|translate"
            [cardOptionBtn]="true"
            [cardOptionBtnIcon]="'feather icon-plus'"
            [cardRouterLink]="'/back-office/product/add/' + model.id"
  >
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
        <tr>
          <th>{{'doctrine.product.name'|translate}}</th>
          <th>{{'doctrine.product.number'|translate}}</th>
          <th>{{'doctrine.product.dealer_price'|translate}}</th>
          <th>{{'doctrine.product.customer_price'|translate}}</th>
          <th>{{'doctrine.product.status'|translate}}</th>
          <th>{{'doctrine.product.position'|translate}}</th>
          <th class="text-end">{{'global.actions'|translate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let product of model.products;let i=index">
          <td>{{product.name}}</td>
          <td>{{product.number}}</td>
          <td>{{product.dealerPrice}}</td>
          <td>{{product.customerPrice}}</td>
          <td>{{(product.status ? 'global.active' : 'global.inactive')|translate}}</td>
          <td><input class="form-control" type="number" (blur)="positionChange(product.id,product.parentPosition)"  [name]="'position'+i" [(ngModel)]="product.parentPosition"  style="max-width: 60px" /></td>
          <td class="text-end">
            <span class="action-button">
              <a class="ripple light ms-2"
                   *ngIf="model.id"
                   routerLink="/back-office/product/{{product.id}}/{{model.id}}">
                <i class="fa fa-pencil fa-lg"></i>
              </a>
            </span>
            <span class="action-button">
              <a class="ripple light ms-2" (click)="showDeleteProduct(product.id, product.name)">
                <i class="fa fa-remove fa-lg"></i>
              </a>
            </span>
          <td>
        </tr>
        </tbody>
      </table>
    </div>
  </app-card>
</div>

<app-modal-basic #deleteProduct>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'Product'} }}</h4>
    <button type="button" class="close basic-close" (click)="deleteProduct.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}}: <span [innerHTML]="productName"></span> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="deleteProduct.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="softDelete()">{{'global.actions.delete'|translate}}</button>
  </div>
</app-modal-basic>
